<template>
    <div class="cover-container d-flex w-100 h-100 p-3 flex-column">
        <header class="masthead mb-auto">
            <div class="inner">
                <nav class="nav nav-masthead justify-content-center">
                    <router-link class="nav-link active" to="/home">Inicio</router-link>
                    <a class="nav-link active" href="#" @click.prevent = "assignData(1)">Aprender</a>
                    <a class="nav-link active" href="#" @click.prevent = "assignData(2)">Practicar</a>
                </nav>
            </div>
        </header>
        <main role="main" class="inner cover" style="padding-left:50px">
            <h2 class="display-4 pb-4 text-info" v-if="mode == 1"><i class="bi-lightbulb"></i> Aprender</h2>
            <h2 class="display-4 pb-4 text-info" v-if="mode == 2"><i class="bi-laptop"></i> Practicar</h2>
            <h1 class="cover-heading" style="color: white">{{ versionName }}</h1>
            <p class="lead" style="color: white">Proyecto integrador 1</p>
            <p style="color: white">Mini proyectos</p>
            <small>
                <nav aria-label="Page navigation example">
                    <ul class="pagination" v-if="mode == 2">
                        <li class="page-item"><a class="page-link" :href="`https://f002.backblazeb2.com/file/csb-eThinking/EthinkingPro/Integradores/mosint/${this.directory}/P1_Simulacion/index.html?access=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`"  target="_blank;" >1</a></li>
                        <li class="page-item"><a class="page-link" :href="`https://f002.backblazeb2.com/file/csb-eThinking/EthinkingPro/Integradores/mosint/${this.directory}/P2_Simulacion/index.html?access=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`"  target="_blank;">2</a></li>
                        <li class="page-item"><a class="page-link" :href="`https://f002.backblazeb2.com/file/csb-eThinking/EthinkingPro/Integradores/mosint/${this.directory}/P3_Simulacion/index.html?access=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`"  target="_blank;">3</a></li>
                        <li class="page-item"><a class="page-link" :href="`https://f002.backblazeb2.com/file/csb-eThinking/EthinkingPro/Integradores/mosint/${this.directory}/P4_Simulacion/index.html?access=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`"  target="_blank;">4</a></li>
                        <li class="page-item"><a class="page-link" :href="`https://f002.backblazeb2.com/file/csb-eThinking/EthinkingPro/Integradores/mosint/${this.directory}/P5_Simulacion/index.html?access=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`"  target="_blank;">5</a></li>
                    </ul>
                    <ul class="pagination" v-if="mode == 1">
    
                        <li class="page-item"><a class="page-link" :href="`https://f002.backblazeb2.com/file/csb-eThinking/EthinkingPro/Integradores/mosint/${this.directory}/P1_Video/index.html?access=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`"  target="_blank;" >1</a></li>
                        <li class="page-item"><a class="page-link" :href="`https://f002.backblazeb2.com/file/csb-eThinking/EthinkingPro/Integradores/mosint/${this.directory}/P2_Video/index.html?access=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`"  target="_blank;">2</a></li>
                        <li class="page-item"><a class="page-link" :href="`https://f002.backblazeb2.com/file/csb-eThinking/EthinkingPro/Integradores/mosint/${this.directory}/P3_Video/index.html?access=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`"  target="_blank;">3</a></li>
                        <li class="page-item"><a class="page-link" :href="`https://f002.backblazeb2.com/file/csb-eThinking/EthinkingPro/Integradores/mosint/${this.directory}/P4_Video/index.html?access=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`"  target="_blank;">4</a></li>
                        <li class="page-item"><a class="page-link" :href="`https://f002.backblazeb2.com/file/csb-eThinking/EthinkingPro/Integradores/mosint/${this.directory}/P5_Video/index.html?access=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`"  target="_blank;">5</a></li>
                    </ul>
                </nav>
            </small>
            <a href="#" class="btn btn-lg btn-light">Aprender <i class="bi-lightbulb"></i></a><br>
            <small><p class="mt-5"><i class="bi-alarm"></i> &nbsp; 10 minutos</p></small>
    
        </main>
    </div>
</template>
<script>
export default {
    name: 'Projects',
    data() {
        return {
            hostname: '',
            usuario: '',
            mode: 1,
            directory: '',
            versionName: '',
        }
    },
    methods: {
        assignData(mode) {
            this.mode = mode
            this.versionName = this.$route.query.name
            setTimeout( () => {
                if(this.$route.query.version == 48 || this.$route.query.version == 10) {
                    if(this.$route.query.version == 48)
                        this.directory = 'wrd19'
                    if(this.$route.query.version == 10)
                        this.directory = 'wrd16'
                    $(".bg-mos1").css('background-image', 'url("../assets/css/images/word2019.jpg")')
                }
                if(this.$route.query.version == 49 || this.$route.query.version == 11) {
                    if(this.$route.query.version == 49)
                        this.directory = 'exc19'
                    if(this.$route.query.version == 11)
                        this.directory = 'exc16'
                    $(".bg-mos1").css('background-image', 'url("../assets/css/images/excel2019.jpg")')
                }
                if(this.$route.query.version == 50 || this.$route.query.version == 43) {
                    if(this.$route.query.version == 50)
                        this.directory = 'ppt19'
                    if(this.$route.query.version == 43)
                        this.directory = 'ppt16'
                    $(".bg-mos1").css('background-image', 'url("../assets/css/images/pp2019.jpg")')
                }
                if(this.$route.query.version == 51) {
                    this.directory = 'wrdxp19'
                    $(".bg-mos1").css('background-image', 'url("../assets/css/images/word2019.jpg")')
                }
            }, 100)
        }
    },
    async mounted() {
		$("body").css('margin-top', '100px')
        document.body.classList.add('bg-mos1')
        this.assignData(1)
    },
    beforeMount() {
        document.body.classList.add('text-left')
    }
}
</script>
<style>
    .bd-placeholder-img {
        font-size: 1.125rem;
        text-anchor: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .bg-mos1 {
        background-size:cover;
        background-repeat:no-repeat;
    }

    @media (min-width: 768px) {
        .bd-placeholder-img-lg {
            font-size: 3.5rem;
        }
    }
</style>